var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(-5.2 -5.2)"},React.createElement("g",{"stroke":"#9fa2a3"},[React.createElement("path",{"d":"M8 20c0 6.627 5.373 12 12 12s12-5.373 12-12S26.627 8 20 8 8 13.373 8 20Z","strokeWidth":"1.6","key":0}),React.createElement("path",{"d":"M20 26v-7a1 1 0 0 0-1-1h-2m1.5-5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M17 26h6","strokeWidth":"2","key":1})])));
}

IconInfo.defaultProps = {"width":"29.6","height":"29.6"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
